import { generateTypes } from '../../utils/HttpReducerHelper';

const myCompanyTeams = generateTypes('TEAMS', 'MY_COMPANY_TEAMS');

export { myCompanyTeams };
